import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "./TestimonialSlider";

export const Whispers = () => {
    return (
        <section id="whispers" data-testid="whispers-section" className="relative px-5 py-28 sm:px-8 lg:py-36">
            <div className="nebula-blob right-[10%] bottom-[0%] h-96 w-96 bg-[#5a189a]/25" />
            <div className="mx-auto max-w-6xl">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9 }}
                    className="mb-16 max-w-2xl"
                >
                    <p className="eyebrow mb-4">Chapter VIII · Whispers from the Parallel Realm</p>
                    <h2 className="text-glow-lilac font-display text-2xl font-bold tracking-wide text-[#f8f7ff] sm:text-3xl lg:text-4xl">
                        THOSE WHO HAVE ALREADY LOOKED
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.9 }}
                    data-testid="press-feature"
                    className="glass-card relative mb-14 grid overflow-hidden md:grid-cols-[1fr_2fr]"
                >
                    <div className="relative h-72 overflow-hidden md:h-full">
                        <img
                            src="/assets/press-modern-mystic.jpg"
                            alt="The Modern Mystic — Three Spiritual Practitioners Redefining Modern Mysticism"
                            className="h-full w-full object-cover object-top"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#18002e]/60 md:bg-gradient-to-r" />
                    </div>
                    <div className="relative p-8 sm:p-10">
                        <div className="mirror-sheen pointer-events-none absolute inset-0 opacity-20" />
                        <p className="eyebrow mb-3">As featured in The Modern Mystic</p>
                        <p className="font-cinzel text-lg font-semibold leading-snug tracking-wide text-[#f8f7ff] sm:text-xl">
                            "THREE SPIRITUAL PRACTITIONERS REDEFINING MODERN MYSTICISM"
                        </p>
                        <p className="mt-3 font-cormorant text-base italic text-[#e0aaff]/80">
                            Mara's command of the white, grey and black currents has made her a practitioner to watch.
                        </p>
                        <p className="mt-6 border-l-2 border-[#c77dff]/50 pl-5 font-cormorant text-xl italic leading-relaxed text-[#f8f7ff]/90">
                            "Mysticism isn't a fantasy. It's a deeper way of seeing, and a braver way of living."
                        </p>
                        <p className="mt-3 font-cinzel text-xs tracking-[0.3em] text-[#c77dff]/70">— MARA</p>
                    </div>
                </motion.div>

                <div className="grid gap-8 md:grid-cols-3">
                    {TESTIMONIALS.map((w, i) => (
                        <motion.blockquote
                            key={w.id}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.8, delay: i * 0.12 }}
                            data-testid="whisper-card"
                            className="glass-card glass-card-hover relative flex flex-col overflow-hidden p-8"
                        >
                            <div className="mirror-sheen pointer-events-none absolute inset-0 opacity-30" />
                            <div className="flex items-center justify-between">
                                <Quote className="h-6 w-6 text-silver/70" />
                                <span className="text-xs tracking-[0.25em] text-[#ffd700]">★★★★★</span>
                            </div>
                            <h3 className="mt-4 font-cinzel text-sm font-semibold leading-snug tracking-wide text-[#f8f7ff]">
                                {w.title}
                            </h3>
                            <p className="mt-3 flex-1 font-cormorant text-lg italic leading-relaxed text-[#f8f7ff]/85">{w.quote}</p>
                            <footer data-testid="whisper-author" className="mt-6 font-cinzel text-xs tracking-[0.2em] text-[#c77dff]/80">
                                {w.author.toUpperCase()}
                            </footer>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
};
